import type { EventItem } from '@/types';

export const events: EventItem[] = [
  {
    id: 'ev001',
    categoryId: 'football',
    title: '英超焦点战：曼城主场迎战利物浦',
    league: '英格兰超级联赛',
    homeTeam: '曼城',
    awayTeam: '利物浦',
    homeScore: 2,
    awayScore: 2,
    startTime: '2026-10-15 19:30',
    date: '2026-10-15',
    region: '国际',
    type: '联赛',
    status: 'live',
    location: '伊蒂哈德球场 · 曼彻斯特',
    cover: 'https://readdy.ai/api/search-image?query=Dramatic%20night%20football%20stadium%20with%20floodlights%20and%20green%20pitch%2C%20stylized%20dark%20atmospheric%20scene%20with%20deep%20blue%20tones%20and%20orange%20accents%2C%20editorial%20sports%20photography%2C%20high%20contrast%2C%20no%20text&width=1200&height=675&seq=ev-football-01&orientation=landscape',
    summary:
      '本轮英超争冠组直接对话，双方近六次交锋各有胜负，中场控制权成为决定走势的关键。主队高位逼抢效率突出，客队边路转换速度依然犀利。',
    tags: ['英超', '争冠组', '焦点战'],
    heat: 98,
    black5Index: 87.4,
    black5Trend: 'up',
    metrics: [
      { label: '控球率', home: 56, away: 44, unit: '%' },
      { label: '射正次数', home: 7, away: 5, unit: '次' },
      { label: '进攻效率', home: 82, away: 74, unit: '' },
      { label: '角球数', home: 6, away: 3, unit: '次' },
    ],
    history: [
      { round: '第9轮', value: 84.2, result: '主胜' },
      { round: '第10轮', value: 85.6, result: '客胜' },
      { round: '第11轮', value: 83.1, result: '平局' },
      { round: '第12轮', value: 86.9, result: '主胜' },
      { round: '第13轮', value: 88.3, result: '主胜' },
      { round: '第14轮', value: 87.4, result: '进行中' },
    ],
    hotspots: ['中场核心回归首发', '客队近五场不败', '历史交锋大球概率偏高'],
    analysis:
      '从黑5综合指数看，主队近期持续走强，指数由 84 区间稳步抬升至 87 以上，进攻效率与射正转化同步改善。客队防守端连续三轮零封，但对手强度有限，本场面对高压逼抢可能出现传球失误。综合判断，主队在控球与前场压迫上略占优势，比赛大概率呈现高节奏对攻。',
  },
  {
    id: 'ev002',
    categoryId: 'football',
    title: '国家德比：皇家马德里对阵巴塞罗那',
    league: '西班牙甲级联赛',
    homeTeam: '皇家马德里',
    awayTeam: '巴塞罗那',
    homeScore: null,
    awayScore: null,
    startTime: '2026-10-16 03:00',
    date: '2026-10-16',
    region: '国际',
    type: '联赛',
    status: 'upcoming',
    location: '伯纳乌球场 · 马德里',
    cover: 'https://readdy.ai/api/search-image?query=Grand%20illuminated%20football%20arena%20at%20dusk%20with%20crowd%20silhouettes%2C%20stylized%20artistic%20rendering%20in%20dark%20navy%20and%20amber%20tones%2C%20cinematic%20editorial%20sports%20photography%2C%20no%20text&width=1200&height=675&seq=ev-football-02&orientation=landscape',
    summary:
      '西甲世纪德比再度上演，两队积分仅差两分，本场结果将直接影响争冠区排名。主队主场火力成疑，客队青训体系输出稳定。',
    tags: ['西甲', '国家德比', '争冠'],
    heat: 95,
    black5Index: 85.2,
    black5Trend: 'flat',
    metrics: [
      { label: '场均进球', home: 2.4, away: 2.1, unit: '球' },
      { label: '射正率', home: 41, away: 38, unit: '%' },
      { label: '进攻效率', home: 79, away: 78, unit: '' },
      { label: '失球数', home: 11, away: 9, unit: '球' },
    ],
    history: [
      { round: '第5轮', value: 82.4, result: '主胜' },
      { round: '第8轮', value: 83.9, result: '平局' },
      { round: '第10轮', value: 84.6, result: '客胜' },
      { round: '第12轮', value: 84.1, result: '主胜' },
      { round: '第13轮', value: 85.8, result: '主胜' },
      { round: '第14轮', value: 85.2, result: '待赛' },
    ],
    hotspots: ['德比历史火药味十足', '主队锋线状态回暖', '客队年轻中场成长迅速'],
    analysis:
      '双方黑5指数接近，差距在 1 个点以内。主队近期主场胜率高但防守稳定性一般，客队客场进攻效率略低于主场。考虑到德比战往往节奏偏紧，前 30 分钟的攻防转换数据值得重点观察。',
  },
  {
    id: 'ev003',
    categoryId: 'football',
    title: '米兰德比：国际米兰对阵 AC 米兰',
    league: '意大利甲级联赛',
    homeTeam: '国际米兰',
    awayTeam: 'AC 米兰',
    homeScore: 1,
    awayScore: 0,
    startTime: '2026-10-14 02:45',
    date: '2026-10-14',
    region: '国际',
    type: '联赛',
    status: 'finished',
    location: '圣西罗球场 · 米兰',
    cover: 'https://readdy.ai/api/search-image?query=Classic%20european%20football%20stadium%20interior%20with%20green%20field%20and%20packed%20stands%2C%20stylized%20dark%20moody%20editorial%20photography%20with%20cool%20blue%20tones%2C%20no%20text&width=1200&height=675&seq=ev-football-03&orientation=landscape',
    summary:
      '同城德比以主队一球小胜收场，比赛节奏紧凑，双方共创造 22 次射门机会，最终由下半场的一次定位球打破僵局。',
    tags: ['意甲', '米兰德比', '已结束'],
    heat: 88,
    black5Index: 80.6,
    black5Trend: 'down',
    metrics: [
      { label: '控球率', home: 52, away: 48, unit: '%' },
      { label: '射门次数', home: 13, away: 9, unit: '次' },
      { label: '进攻效率', home: 76, away: 71, unit: '' },
      { label: '抢断成功', home: 18, away: 15, unit: '次' },
    ],
    history: [
      { round: '第9轮', value: 83.5, result: '主胜' },
      { round: '第10轮', value: 82.1, result: '客胜' },
      { round: '第11轮', value: 81.4, result: '平局' },
      { round: '第12轮', value: 82.8, result: '主胜' },
      { round: '第13轮', value: 81.2, result: '客胜' },
      { round: '第14轮', value: 80.6, result: '主胜' },
    ],
    hotspots: ['定位球决定胜负', '两队门将多次神扑', '同城德比气氛火爆'],
    analysis:
      '主队凭借下半场定位球取胜，黑5指数在赛后小幅回落，说明整体进攻转化仍有提升空间。客队虽败但中场组织数据占优，后续赛程值得关注。',
  },
  {
    id: 'ev004',
    categoryId: 'basketball',
    title: 'NBA 常规赛：湖人主场迎战凯尔特人',
    league: 'NBA 常规赛',
    homeTeam: '洛杉矶湖人',
    awayTeam: '波士顿凯尔特人',
    homeScore: 108,
    awayScore: 112,
    startTime: '2026-10-15 10:30',
    date: '2026-10-15',
    region: '国际',
    type: '联赛',
    status: 'finished',
    location: '克雷普托中心 · 洛杉矶',
    cover: 'https://readdy.ai/api/search-image?query=Indoor%20basketball%20arena%20with%20spotlights%20on%20polished%20hardwood%20court%2C%20stylized%20dark%20dramatic%20editorial%20photography%20with%20orange%20and%20deep%20blue%20accents%2C%20no%20text&width=1200&height=675&seq=ev-basketball-01&orientation=landscape',
    summary:
      '东西部豪门对话，客队末节连续命中三分完成逆转。双方篮板争夺激烈，替补得分成为胜负分水岭。',
    tags: ['NBA', '常规赛', '已结束'],
    heat: 92,
    black5Index: 83.7,
    black5Trend: 'up',
    metrics: [
      { label: '投篮命中率', home: 46, away: 49, unit: '%' },
      { label: '三分命中', home: 12, away: 17, unit: '记' },
      { label: '篮板数', home: 44, away: 47, unit: '个' },
      { label: '助攻数', home: 24, away: 29, unit: '次' },
    ],
    history: [
      { round: '第1场', value: 79.8, result: '主胜' },
      { round: '第2场', value: 81.2, result: '客胜' },
      { round: '第3场', value: 82.5, result: '主胜' },
      { round: '第4场', value: 83.1, result: '主胜' },
      { round: '第5场', value: 84.6, result: '客胜' },
      { round: '第6场', value: 83.7, result: '客胜' },
    ],
    hotspots: ['末节三分雨逆转', '替补席贡献 42 分', '双方篮板数接近'],
    analysis:
      '客队外线手感火热，三分命中数与助攻数全面领先，黑5指数保持高位。主队内线优势未能转化为得分，罚球命中率下滑是隐忧。',
  },
  {
    id: 'ev005',
    categoryId: 'basketball',
    title: 'CBA 焦点对决：辽宁本钢对阵广东宏远',
    league: '中国男子篮球职业联赛',
    homeTeam: '辽宁本钢',
    awayTeam: '广东宏远',
    homeScore: null,
    awayScore: null,
    startTime: '2026-10-15 19:35',
    date: '2026-10-15',
    region: '国内',
    type: '联赛',
    status: 'upcoming',
    location: '沈阳奥体中心 · 沈阳',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20basketball%20court%20with%20blue%20seating%20and%20overhead%20lights%2C%20stylized%20dark%20cinematic%20sports%20photography%20with%20cool%20tones%20and%20warm%20highlights%2C%20no%20text&width=1200&height=675&seq=ev-basketball-02&orientation=landscape',
    summary:
      '国内顶级对决，两队近年多次在总决赛相遇。主队后场组织稳定，客队年轻锋线冲击力十足，开局节奏值得关注。',
    tags: ['CBA', '焦点战', '国内'],
    heat: 86,
    black5Index: 82.1,
    black5Trend: 'flat',
    metrics: [
      { label: '场均得分', home: 105, away: 102, unit: '分' },
      { label: '场均篮板', home: 43, away: 41, unit: '个' },
      { label: '三分命中率', home: 38, away: 36, unit: '%' },
      { label: '失误数', home: 12, away: 14, unit: '次' },
    ],
    history: [
      { round: '第1轮', value: 80.4, result: '主胜' },
      { round: '第2轮', value: 81.6, result: '客胜' },
      { round: '第3轮', value: 82.8, result: '主胜' },
      { round: '第4轮', value: 81.9, result: '主胜' },
      { round: '第5轮', value: 82.4, result: '客胜' },
      { round: '第6轮', value: 82.1, result: '待赛' },
    ],
    hotspots: ['老牌强队对话', '后场组织对位关键', '主场氛围加成明显'],
    analysis:
      '两队黑5指数长期胶着，主队主场胜率略高。客队失误控制稍逊，若被主队打出快攻转换，分差可能迅速拉开。',
  },
  {
    id: 'ev006',
    categoryId: 'esports',
    title: 'LPL 季后赛：JDG 对阵 TES',
    league: '英雄联盟职业联赛',
    homeTeam: 'JDG 京东',
    awayTeam: 'TES 滔搏',
    homeScore: 2,
    awayScore: 1,
    startTime: '2026-10-15 17:00',
    date: '2026-10-15',
    region: '国内',
    type: '杯赛',
    status: 'live',
    location: '上海主场电竞馆 · 上海',
    cover: 'https://readdy.ai/api/search-image?query=Futuristic%20esports%20arena%20with%20large%20screens%20and%20purple%20stage%20lighting%2C%20stylized%20dark%20cyber%20atmosphere%20with%20teal%20accents%2C%20editorial%20photography%2C%20no%20text&width=1200&height=675&seq=ev-esports-01&orientation=landscape',
    summary:
      '季后赛关键局进行中，前两局双方各下一城，第三局主队通过大龙团战扩大经济领先，比赛悬念仍在。',
    tags: ['LPL', '季后赛', '进行中'],
    heat: 90,
    black5Index: 88.9,
    black5Trend: 'up',
    metrics: [
      { label: '场均经济', home: 62.4, away: 60.1, unit: 'k' },
      { label: '击杀数', home: 38, away: 33, unit: '次' },
      { label: '一血率', home: 67, away: 55, unit: '%' },
      { label: '大龙控制', home: 3, away: 2, unit: '条' },
    ],
    history: [
      { round: '常规赛1', value: 85.2, result: '主胜' },
      { round: '常规赛2', value: 86.8, result: '客胜' },
      { round: '常规赛3', value: 87.4, result: '主胜' },
      { round: '季后赛1', value: 88.1, result: '主胜' },
      { round: '季后赛2', value: 89.2, result: '客胜' },
      { round: '季后赛3', value: 88.9, result: '进行中' },
    ],
    hotspots: ['大龙团战定乾坤', '双核发育良好', 'BP 针对下路'],
    analysis:
      '主队黑5指数保持领先，一血率与大龙控制均占优，前中期节奏把握更好。客队团战执行力强，若拖入后期仍有翻盘空间。',
  },
  {
    id: 'ev007',
    categoryId: 'esports',
    title: 'KPL 常规赛：成都 AG 超玩会对阵武汉 eStar',
    league: '王者荣耀职业联赛',
    homeTeam: '成都 AG 超玩会',
    awayTeam: '武汉 eStar',
    homeScore: 3,
    awayScore: 2,
    startTime: '2026-10-13 20:00',
    date: '2026-10-13',
    region: '国内',
    type: '联赛',
    status: 'finished',
    location: '成都电竞中心 · 成都',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20esports%20stage%20with%20players%20and%20glowing%20screens%2C%20stylized%20dark%20moody%20digital%20art%20with%20orange%20and%20teal%20highlights%2C%20no%20text&width=1200&height=675&seq=ev-esports-02&orientation=landscape',
    summary:
      '五局鏖战，主队在决胜局凭借稳守反击拿下比赛。双方野区资源争夺激烈，团战配合成为关键。',
    tags: ['KPL', '常规赛', '已结束'],
    heat: 84,
    black5Index: 79.8,
    black5Trend: 'down',
    metrics: [
      { label: '场均经济', home: 58.2, away: 57.4, unit: 'k' },
      { label: '击杀数', home: 42, away: 45, unit: '次' },
      { label: '控龙率', home: 60, away: 52, unit: '%' },
      { label: '一塔率', home: 72, away: 64, unit: '%' },
    ],
    history: [
      { round: '第8轮', value: 82.4, result: '主胜' },
      { round: '第9轮', value: 83.1, result: '客胜' },
      { round: '第10轮', value: 82.6, result: '主胜' },
      { round: '第11轮', value: 81.2, result: '客胜' },
      { round: '第12轮', value: 80.4, result: '主胜' },
      { round: '第13轮', value: 79.8, result: '主胜' },
    ],
    hotspots: ['决胜局稳守反击', '野区资源争夺激烈', '新人打野首发'],
    analysis:
      '主队控龙率领先但黑5指数有所回落，说明经济转化效率出现波动。客队击杀数更多但团战收益偏低，需要优化开团时机。',
  },
  {
    id: 'ev008',
    categoryId: 'tennis',
    title: '温网男单决赛：阿尔卡拉斯对阵辛纳',
    league: '温布尔登网球锦标赛',
    homeTeam: '阿尔卡拉斯',
    awayTeam: '辛纳',
    homeScore: 3,
    awayScore: 2,
    startTime: '2026-10-12 21:00',
    date: '2026-10-12',
    region: '国际',
    type: '杯赛',
    status: 'finished',
    location: '中央球场 · 伦敦',
    cover: 'https://readdy.ai/api/search-image?query=Grass%20tennis%20court%20with%20net%20and%20empty%20stands%20under%20soft%20evening%20light%2C%20stylized%20dark%20editorial%20sports%20photography%20with%20deep%20blue%20and%20amber%20tones%2C%20no%20text&width=1200&height=675&seq=ev-tennis-01&orientation=landscape',
    summary:
      '五盘大战两小时五十八分钟，主队在决胜盘抢七中顶住压力捧杯。双方一发得分率与制胜分数据均处于顶尖水平。',
    tags: ['温网', '决赛', '已结束'],
    heat: 89,
    black5Index: 86.3,
    black5Trend: 'up',
    metrics: [
      { label: '一发得分率', home: 78, away: 75, unit: '%' },
      { label: '制胜分', home: 54, away: 49, unit: '分' },
      { label: '破发成功', home: 5, away: 4, unit: '次' },
      { label: '非受迫失误', home: 32, away: 38, unit: '次' },
    ],
    history: [
      { round: '1/4 决赛', value: 84.1, result: '主胜' },
      { round: '半决赛', value: 85.4, result: '主胜' },
      { round: '第一盘', value: 85.9, result: '主胜' },
      { round: '第二盘', value: 86.2, result: '客胜' },
      { round: '第四盘', value: 85.8, result: '客胜' },
      { round: '决胜盘', value: 86.3, result: '主胜' },
    ],
    hotspots: ['决胜盘抢七定胜负', '草地一发威力十足', '年轻一代巅峰对话'],
    analysis:
      '主队一发得分率与制胜分均略占优势，黑5指数在关键盘口维持稳定上行。客队非受迫失误偏多，是丢掉决胜盘的主要原因。',
  },
  {
    id: 'ev009',
    categoryId: 'tennis',
    title: 'ATP 上海大师赛：德约科维奇对阵梅德韦杰夫',
    league: 'ATP 1000 大师赛',
    homeTeam: '德约科维奇',
    awayTeam: '梅德韦杰夫',
    homeScore: null,
    awayScore: null,
    startTime: '2026-10-17 18:30',
    date: '2026-10-17',
    region: '国内',
    type: '杯赛',
    status: 'upcoming',
    location: '旗忠森林体育城 · 上海',
    cover: 'https://readdy.ai/api/search-image?query=Hard%20court%20tennis%20court%20with%20blue%20surface%20and%20spotlights%2C%20stylized%20dark%20cinematic%20sports%20image%20with%20cool%20tones%20and%20warm%20accents%2C%20no%20text&width=1200&height=675&seq=ev-tennis-02&orientation=landscape',
    summary:
      '硬地经典对位再度上演，双方交手记录接近。主队底线相持稳定，客队发球与反拍直线是主要得分武器。',
    tags: ['ATP', '大师赛', '国内'],
    heat: 82,
    black5Index: 83.5,
    black5Trend: 'flat',
    metrics: [
      { label: '一发得分率', home: 76, away: 74, unit: '%' },
      { label: 'ACE 球', home: 9, away: 13, unit: '个' },
      { label: '破发点转化', home: 42, away: 38, unit: '%' },
      { label: '制胜分', home: 41, away: 46, unit: '分' },
    ],
    history: [
      { round: '1/8 决赛', value: 82.8, result: '主胜' },
      { round: '1/4 决赛', value: 83.2, result: '主胜' },
      { round: '半决赛', value: 83.9, result: '主胜' },
      { round: '第一盘', value: 83.4, result: '待赛' },
      { round: '第二盘', value: 83.6, result: '待赛' },
      { round: '第三盘', value: 83.5, result: '待赛' },
    ],
    hotspots: ['硬地巅峰对位', 'ACE 球数量对比', '破发点把握成胜负关键'],
    analysis:
      '双方黑5指数非常接近，主队破发点转化略优，客队发球威力更强。硬地节奏偏快，率先进入状态的一方更有可能掌握主动。',
  },
  {
    id: 'ev010',
    categoryId: 'baseball',
    title: 'MLB 世界大赛：道奇对阵洋基',
    league: '美国职业棒球大联盟',
    homeTeam: '洛杉矶道奇',
    awayTeam: '纽约洋基',
    homeScore: 5,
    awayScore: 3,
    startTime: '2026-10-15 08:10',
    date: '2026-10-15',
    region: '国际',
    type: '杯赛',
    status: 'finished',
    location: '道奇体育场 · 洛杉矶',
    cover: 'https://readdy.ai/api/search-image?query=Baseball%20stadium%20at%20dusk%20with%20green%20field%20and%20stadium%20lights%2C%20stylized%20dark%20editorial%20sports%20photography%20with%20deep%20blue%20and%20amber%20tones%2C%20no%20text&width=1200&height=675&seq=ev-baseball-01&orientation=landscape',
    summary:
      '世界大赛首战主队先下一城，第七局连续安打打下三分锁定胜局。双方先发投手均投满六局，牛棚对决成为看点。',
    tags: ['MLB', '世界大赛', '已结束'],
    heat: 80,
    black5Index: 78.4,
    black5Trend: 'down',
    metrics: [
      { label: '安打数', home: 9, away: 7, unit: '支' },
      { label: '本垒打', home: 2, away: 1, unit: '支' },
      { label: '三振数', home: 10, away: 8, unit: '次' },
      { label: '残垒数', home: 6, away: 9, unit: '个' },
    ],
    history: [
      { round: '分区赛', value: 80.2, result: '主胜' },
      { round: '冠军赛', value: 79.4, result: '主胜' },
      { round: '第一局', value: 79.8, result: '平' },
      { round: '第三局', value: 78.9, result: '客胜' },
      { round: '第五局', value: 78.2, result: '主胜' },
      { round: '第七局', value: 78.4, result: '主胜' },
    ],
    hotspots: ['第七局连续安打', '牛棚稳定发挥', '两队残垒数偏多'],
    analysis:
      '主队安打效率更高，黑5指数在系列赛初期保持平稳。客队残垒数偏多，关键局把握能力有待提升。',
  },
  {
    id: 'ev011',
    categoryId: 'hockey',
    title: 'NHL 常规赛：多伦多枫叶对阵坦帕湾闪电',
    league: '北美职业冰球联赛',
    homeTeam: '多伦多枫叶',
    awayTeam: '坦帕湾闪电',
    homeScore: 4,
    awayScore: 2,
    startTime: '2026-10-15 09:00',
    date: '2026-10-15',
    region: '国际',
    type: '联赛',
    status: 'finished',
    location: '丰业银行竞技场 · 多伦多',
    cover: 'https://readdy.ai/api/search-image?query=Ice%20hockey%20rink%20with%20white%20ice%20and%20stadium%20lights%2C%20stylized%20dark%20editorial%20sports%20photography%20with%20cool%20blue%20tones%20and%20warm%20highlights%2C%20no%20text&width=1200&height=675&seq=ev-hockey-01&orientation=landscape',
    summary:
      '主队第二节连续两次强打得分确立优势，门将全场完成 32 次扑救。双方身体对抗激烈，罚时数据偏高。',
    tags: ['NHL', '常规赛', '已结束'],
    heat: 76,
    black5Index: 77.1,
    black5Trend: 'up',
    metrics: [
      { label: '射正数', home: 31, away: 34, unit: '次' },
      { label: '扑救数', home: 32, away: 27, unit: '次' },
      { label: '强打得分', home: 2, away: 1, unit: '次' },
      { label: '罚时', home: 12, away: 16, unit: '分钟' },
    ],
    history: [
      { round: '第6轮', value: 74.8, result: '客胜' },
      { round: '第7轮', value: 75.6, result: '主胜' },
      { round: '第8轮', value: 76.2, result: '主胜' },
      { round: '第9轮', value: 76.9, result: '客胜' },
      { round: '第10轮', value: 76.5, result: '主胜' },
      { round: '第11轮', value: 77.1, result: '主胜' },
    ],
    hotspots: ['强打效率成关键', '门将神勇扑救 32 次', '身体对抗激烈'],
    analysis:
      '主队门将发挥出色，射正数虽落后但转化效率更高，黑5指数稳步上行。客队罚时偏多，强打防守需要加强。',
  },
  {
    id: 'ev012',
    categoryId: 'football',
    title: '欧冠小组赛：拜仁慕尼黑对阵巴黎圣日耳曼',
    league: '欧洲冠军联赛',
    homeTeam: '拜仁慕尼黑',
    awayTeam: '巴黎圣日耳曼',
    homeScore: null,
    awayScore: null,
    startTime: '2026-10-18 03:00',
    date: '2026-10-18',
    region: '国际',
    type: '杯赛',
    status: 'upcoming',
    location: '安联球场 · 慕尼黑',
    cover: 'https://readdy.ai/api/search-image?query=European%20football%20stadium%20at%20night%20with%20bright%20floodlights%20and%20blue%20pitch%20lines%2C%20stylized%20dark%20cinematic%20editorial%20photography%20with%20deep%20navy%20and%20amber%20accents%2C%20no%20text&width=1200&height=675&seq=ev-football-04&orientation=landscape',
    summary:
      '欧冠小组头名之争，两队均需三分巩固出线形势。主队高位压迫体系成熟，客队反击速度极快。',
    tags: ['欧冠', '小组赛', '焦点战'],
    heat: 93,
    black5Index: 86.8,
    black5Trend: 'up',
    metrics: [
      { label: '场均控球', home: 61, away: 55, unit: '%' },
      { label: '射正次数', home: 6.2, away: 5.4, unit: '次' },
      { label: '进攻效率', home: 84, away: 81, unit: '' },
      { label: '越位次数', home: 2.1, away: 3.2, unit: '次' },
    ],
    history: [
      { round: '小组第1轮', value: 84.6, result: '主胜' },
      { round: '小组第2轮', value: 85.2, result: '客胜' },
      { round: '小组第3轮', value: 86.1, result: '主胜' },
      { round: '小组第4轮', value: 86.6, result: '主胜' },
      { round: '小组第5轮', value: 86.3, result: '平局' },
      { round: '小组第6轮', value: 86.8, result: '待赛' },
    ],
    hotspots: ['小组头名之争', '高位压迫对反击', '出线形势胶着'],
    analysis:
      '主队黑5指数持续走高，攻防两端数据均衡。客队进攻效率紧随其后，反击中的速度优势是最大威胁。出线主动权掌握在主场一方。',
  },
];

export const findEvent = (id: string): EventItem | undefined =>
  events.find((item) => item.id === id);

export const eventsByCategory = (categoryId: string): EventItem[] =>
  events.filter((item) => item.categoryId === categoryId);